import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'icm-localDB',
      storage,
      whitelist: [
        'patient',
        'funcionario',
        'doctor',
        'prontuario',
        'eco',
        'ergo',
      ],
    },
    reducers
  );

  return persistedReducer;
};
